<style lang="scss">
.queryform {
	.vview-formitem {
		margin-bottom: 6px;
		min-height: 32px;
	}
	.vview-formitem-content {
		font-weight: 800;
	}
}
</style>

<template>
	<vForm class="queryform clearfix" v-bind="getFormProps">
		<template v-for="(item,index) in formdata">
			<vCol v-if="handleVisible(item)" :key="index" v-bind="getColProps(item)">
				<vFormItem v-bind="getFormItemProps(item)">
					<vTooltip v-if="item.popper" v-bind="getPopperProps(item)">
						<compRender v-for="data in getRenderProps(item)" :key="data._key" v-bind="data" />
					</vTooltip>
					<compRender v-else v-for="data in getRenderProps(item)" :key="data._key" v-bind="data" />
				</vFormItem>
			</vCol>
		</template>
	</vForm>
</template>

<script>
import formmixin from "./formmixin";
export default {
	mixins: [formmixin],
	computed: {
		getFormProps() {
			return { labelWidth: 120, ...this.$attrs };
		}
	},
	methods: {
		getFormItemProps(item) {
			const { label, langKey, formItem } = item;
			return {
				label: langKey ? this.$t(langKey, { defaultValue: label }) : label,
				...formItem
			};
		},
		getPopperProps(item) {
			return {
				content: item.popper,
				gpu: true
				// popperStyle: 'max-width:unset;padding:0;'
			}
		},
		getRenderProps(item) {
			let { key, render, options, children, style, class: className, props, complex, tag, custom } = item;
			if (render) {
				return [{
					tag: 'div',
					style,
					_key: 0,
					class: className,
					children: render
				}]
			}
			const value = this.value[key];
			if (custom && this.isGroupFormChild(tag)) {
				className = className || 'margin-right-15';
				return options instanceof Array ? options.map((item, index) => {
					return {
						tag,
						style,
						class: className,
						_key: index,
						attrs: { value: item.key ? this.value[item.key] : value, ...props, ...item, readonly: true },
						children
					}
				}) : [{
					tag,
					style,
					class: className,
					_key: 0,
					attrs: { value, ...props, readonly: true },
					children
				}]
			}
			if (custom && tag) {
				return [{
					tag,
					style,
					class: className,
					attrs: { value, ...props, readonly: true },
					children,
					_key: 0,
				}]
			}
			return [{
				tag: 'div',
				class:'text-wrap',
				domProps: {
					innerHTML: this.getValueText(item, value)
				}
			}]
		},
	}
};



</script>